import { Component, inject, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AutocompleteService } from '../../../../services/planning/autocomplete.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-text-input',
    standalone: false,
    templateUrl: './text-input.component.html',
    styleUrl: './text-input.component.scss',
})
export class TextInputComponent extends InputComponent implements OnInit {
    private autocompleteService = inject(AutocompleteService);

    autocomplete: Observable<string[]>;

    ngOnInit() {
        if (this.field.autocomplete) {
            let autocompleteOptions = [];
            const subs = new Subscription();
            subs.add(
                this.autocompleteService.getByType(this.field.autocomplete).subscribe(list => {
                    autocompleteOptions = list;
                    subs?.unsubscribe();
                })
            );
            this.autocomplete = this.fc.valueChanges.pipe(
                startWith(''),
                map(value => {
                    if (value) {
                        return autocompleteOptions.filter(option =>
                            option.toLowerCase().trim().includes(value.toLowerCase().trim())
                        );
                    }
                    return autocompleteOptions.slice(0, 5);
                })
            );
        }
    }
}
